/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../utils/constants';

const IDS = {
  HELMET_GENERAL_PAGETITLE: 'documents.helmet.general.pageTitle',
  HELMET_PAGETITLE_ERROR: 'documents.helmet.pageTitle.error',
  HELMET_SECTIONTITLE: 'documents.helmet.sectionTitle',
  HELMET_STATEMENTS_PAGETITLE: 'documents.helmet.statements.pageTitle',
  HOME_CARD_FORMSANDRESOURCES_ARIALABEL: 'documents.home.card.formsAndResources.ariaLabel',
  HOME_CARD_FORMSANDRESOURCES_BODYTEXT: 'documents.home.card.formsAndResources.bodyText',
  HOME_CARD_FORMSANDRESOURCES_EMPTYLABEL: 'documents.home.card.formsAndResources.emptyLabel',
  HOME_CARD_FORMSANDRESOURCES_HEADING: 'documents.home.card.formsAndResources.heading',
  HOME_CARD_FORMSANDRESOURCES_NONEMPTYLABEL: 'documents.home.card.formsAndResources.nonemptyLabel',
  HOME_CARD_PAYOFF_ARIALABEL: 'documents.home.card.payoff.ariaLabel',
  HOME_CARD_PAYOFF_BODYTEXT: 'documents.home.card.payoff.bodyText',
  HOME_CARD_PAYOFF_EMPTYLABEL: 'documents.home.card.payoff.emptyLabel',
  HOME_CARD_PAYOFF_HEADING: 'documents.home.card.payoff.heading',
  HOME_CARD_PAYOFF_NONEMPTYLABEL: 'documents.home.card.payoff.nonemptyLabel',
  HOME_CARD_STATEMENTS_ARIALABEL: 'documents.home.card.statements.ariaLabel',
  HOME_CARD_STATEMENTS_BODYTEXT: 'documents.home.card.statements.bodyText',
  HOME_CARD_STATEMENTS_EMPTYLABEL: 'documents.home.card.statements.emptyLabel',
  HOME_CARD_STATEMENTS_HEADING: 'documents.home.card.statements.heading',
  HOME_CARD_STATEMENTS_NONEMPTYLABEL: 'documents.home.card.statements.nonemptyLabel',
  STATEMENTS_TYPE_MORTGAGEBILLINGSTATEMENT: 'documents.statements.type.mortgageBillingStatement',
};

const enMessages = {
  [IDS.HELMET_GENERAL_PAGETITLE]: 'Forms and Resources',
  [IDS.HELMET_PAGETITLE_ERROR]: 'Error',
  [IDS.HELMET_SECTIONTITLE]: 'Documents',
  [IDS.HELMET_STATEMENTS_PAGETITLE]: 'Statements',
  [IDS.HOME_CARD_FORMSANDRESOURCES_ARIALABEL]: 'view forms and resources',
  [IDS.HOME_CARD_FORMSANDRESOURCES_BODYTEXT]: 'Download forms including Change of Address, Third Party Authorization, and Lien Waiver.',
  [IDS.HOME_CARD_FORMSANDRESOURCES_EMPTYLABEL]: 'No Documents',
  [IDS.HOME_CARD_FORMSANDRESOURCES_HEADING]: 'Forms and Resources',
  [IDS.HOME_CARD_FORMSANDRESOURCES_NONEMPTYLABEL]: '{numberOfItems, plural, one {# Document} other {# Documents}}',
  [IDS.HOME_CARD_PAYOFF_ARIALABEL]: 'or view past payoff statements',
  [IDS.HOME_CARD_PAYOFF_BODYTEXT]: 'Request a statement or view past Payoff Statements.',
  [IDS.HOME_CARD_PAYOFF_EMPTYLABEL]: 'Request Payoff Statement',
  [IDS.HOME_CARD_PAYOFF_HEADING]: 'Payoff Statements',
  [IDS.HOME_CARD_PAYOFF_NONEMPTYLABEL]: '{numberOfItems, plural, one {# Payoff Statement} other {# Payoff Statements}}',
  [IDS.HOME_CARD_STATEMENTS_ARIALABEL]: 'view statements',
  [IDS.HOME_CARD_STATEMENTS_BODYTEXT]: 'Access your monthly billing, escrow analysis, and year-end statements.',
  [IDS.HOME_CARD_STATEMENTS_EMPTYLABEL]: 'No Statements',
  [IDS.HOME_CARD_STATEMENTS_HEADING]: 'Statements',
  [IDS.HOME_CARD_STATEMENTS_NONEMPTYLABEL]: '{numberOfItems, plural, one {# Statement} other {# Statements }}',
  [IDS.STATEMENTS_TYPE_MORTGAGEBILLINGSTATEMENT]: 'Mortgage Billing Statement',
};

const enMurabahaMessages = {
  ...enMessages,
  [IDS.HOME_CARD_PAYOFF_ARIALABEL]: 'or view past discounted Murabaha debt/payoff statements',
  [IDS.HOME_CARD_PAYOFF_BODYTEXT]: 'Request a statement or view past Discounted Murabaha Debt/Payoff Statements.',
  [IDS.HOME_CARD_PAYOFF_EMPTYLABEL]: 'Request Payoff Statement',
  [IDS.HOME_CARD_PAYOFF_HEADING]: 'Discounted Murabaha Debt/Payoff Statements',
  [IDS.HOME_CARD_PAYOFF_NONEMPTYLABEL]: '{numberOfItems, plural, one {# Payoff Statement} other {# Payoff Statements}}',
  [IDS.STATEMENTS_TYPE_MORTGAGEBILLINGSTATEMENT]: 'Murabaha Billing Statement',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
